import * as React from 'react';
import EnableAiConfirmationDialog from '../../../../common/EnableAiConfirmationDialog';

type OwnProps = {
    onConfirm: () => void;
    onDismiss: () => void;
}

const EnableAiInsightsConfirmationDialog = (props: OwnProps) => 
    <EnableAiConfirmationDialog
        title="Enable PPM Insights AI"
        onConfirm={props.onConfirm}
        onDismiss={props.onDismiss}
    />;
export default EnableAiInsightsConfirmationDialog;